import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="News-Fresh-App" link="https://github.com/ashwanisng/New-Fresh-App" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
NewsFresh App which keeps you updated with the Latest News!
    </ProjectCard>
    <ProjectCard title="To-Do-List-App" link="https://github.com/ashwanisng/To-Do-List-App" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
To-Do is a task management app to help you stay organized and manage your day-to-day.
    </ProjectCard>
    <ProjectCard title="Flash-Chat-App" link="https://github.com/ashwanisng/Flash-Chat-App" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
FlashChat is a simple, group texting application that allows users to communicate free of cost without any limitations.
    </ProjectCard>
    <ProjectCard title="Covid-19-Data-Analysis" link="https://github.com/ashwanisng/Covid-19-Data-Analysis" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
India COVID 19 Data Analysis.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      